<template>
  <div>
    <andes-header></andes-header>

    <div class="container payment-page">
      <div class="row">
        <div class="col-sm-9">

          <div class="row">
            <div class="col-12">
              <div class="current-srch-container">
                <div class="row d-flex align-items-center text-center text-sm-left">
                  <div class="col-12 col-sm-6 ">
                    <h4 class="payment-title m-0">REALIZAR PAGO PENDIENTE</h4>
                  </div>
                  <div class="col-12 col-sm-6">
                    <div class="reservation text-center">Reserva: {{booking.RecordLocator}}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr>

          <div class="itin">
            <payment-summary class="mb-3"></payment-summary>
          </div>

<!--           <div class="row mt-4 ml-3 mr-3">
            <div class="col">
              <input type="radio" id="credit" value="card" v-model="picked">
              <label for="credit" class="ml-3">Tarjetas Crédito/Débito</label>
            </div>
            <div class="col" v-if="getAP">
              <input type="radio" id="cash" value="cash" v-model="picked">
              <label for="cash" class="ml-3">Efectivo</label>
            </div>
          </div> -->

          <div class="card shadow mt-3" v-if="booking.BalanceDue > 0">
            <div class="card-body">
              <h3 class="total-title">TOTAL A PAGAR:  <span>ARS {{toCurrencyFormat(booking.BalanceDue)}}</span></h3>
              <hr/>
              <!-- <mp-form ref="mp" v-if="picked == 'card'"></mp-form> 
              <mp-cash-form ref="mpCash" v-else></mp-cash-form -->
              <div class="container text-right p-2">
                <button type="button" class="btn btn-andes" @click="onContinue">Pagar</button>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="col-sm-3">-->
<!--        </div>-->
      </div>
    </div>
    <loading-modal v-if="loading"></loading-modal>
  </div>
</template>

<script>
  import { getAvailability } from '@/api/api';
  import SummaryForm from "../components/SummaryForm";
  import Breadcrumb from "../components/Breadcrumb";
  import { mapState } from 'vuex';
  //import MpForm from "../components/payment/MercadoPagoForm";
  //import MpCashForm from "../components/payment/MercadoPagoCashForm";
  import AndesHeader from "../components/AndesHeader";
  import LoadingModal from "../components/LoadingModal";
  import PaymentSummary from "../components/itinerary/PaymentSummary";
  import {formatMoney} from "../utils/utils";
  var moment = require('moment');

  export default {
    components: {
      PaymentSummary,
      LoadingModal,
      AndesHeader,
      //MpForm,
      //MpCashForm,
      Breadcrumb,
      SummaryForm},
    name: 'pending-payment-page',
    computed: {
      ...mapState(['booking', 'loading', 'checkboxTerms']),
      getAP: function() {
        if (this.booking.Passengers[0] && this.booking.Passengers[0].Segments[0]
            && this.booking.Passengers[0].Segments[0].Legs && this.booking.Passengers[0].Segments[0].Legs[0]
            && this.booking.Passengers[0].Segments[0].Legs[0].InventoryLeg ) {
          let departureDate = moment(this.booking.Passengers[0].Segments[0].Legs[0].InventoryLeg.STD);
          let today = moment(new Date());
          let diff =  moment.duration(departureDate.diff(today));
          if (diff.days()>=1){
            return true;
          }
        }
      }

    },
    data: function() {
      return {
        picked: "card"
      }
    },
    methods: {
     onContinue: function () {
       if (this.booking.BalanceDue <= 0) {
         this.$router.replace("itinerary");
       } else {
          this.$refs.mp.onMakePayment();
       }
       /*gtag('event', 'pay_attempt', {
         'event_category':"payment"
       });*/

     },
      toCurrencyFormat: function (amount) {
        return formatMoney(amount);
      }
    }, mounted() {
      if (_.isEmpty(this.booking)){
       this.$router.replace('/');
      }
    }
  }
</script>

